import React from 'react';
import classnames from 'classnames';

export default function Modal({ children, className, lg, sm }) {
  const clazz = classnames(className, 'modal', 'show', 'd-block');
  return (
    <div className={clazz} id="modal" tabIndex="-1" role="dialog">
      <div
        className={classnames('modal-dialog modal-dialog-centered', sm && ' modal-sm', lg && 'modal-lg')}
        role="document"
      >
        {children}
      </div>
    </div>
  );
}
